import React from 'react';
import { LinearProgress } from '@material-ui/core';
import LogoAnimation from '@views/Testing/components/LogoAnimation'
import SVGIcon from '@components/SvgIcon';

import {ReactComponent as ClientMgIcon} from '~/assets/icons/menu/ClientMg/ClientMgBlack.svg';

import ContactsIcon from '@material-ui/icons/Contacts';
import LocalActivityIcon from '@material-ui/icons/LocalActivity';
import DateRangeIcon from '@material-ui/icons/DateRange';
import BusinessIcon from '@material-ui/icons/Business';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { mainColor } from '~/assets/jss/material-dashboard-react/components/sidebarStyle';

const ContactsPage =React.lazy(()=>import('crm/ContactsPage'))
const ActivitiesPages =React.lazy(()=>import('crm/ActivitiesPage'))
const CalendarPage =React.lazy(()=>import('crm/CalendarPage'))
const DealsPage =React.lazy(()=>import('crm/DealsPage'))
const DashboardPage =React.lazy(()=>import('crm/DashboardPage'))


// error boundary
import ErrorBoundary from '@components/ErrorBoundary';

type suspense = React.LazyExoticComponent<React.ComponentType<{}>>
type withError = React.FC<{children:React.ReactNode| suspense}>
const WithSusError:withError = (props) => {
  return (
    <ErrorBoundary>
       <React.Suspense fallback={<LogoAnimation/>}>
         {props.children}
       </React.Suspense>
    </ErrorBoundary>
  );
};

const IconSize = '2.1rem';

const rootRoutes = [
  {
    parent:"CRM",
    icon:<SVGIcon style={{color:mainColor}} fontSize={IconSize} viewBox={'0 0 1400 1400'} svg={ClientMgIcon}/>,
    layout:'/admin',
    nestedRoutes:[
    {
      path: "/crm/contacts",
      name: "Contact Lists",
      rtlName: "قائمة الإتصال",
      icon: <SVGIcon style={{color:mainColor}} fontSize={'1.25rem'} viewBox={'0 0 25 25'} svg={ContactsIcon}/> ,
      component: <WithSusError><ContactsPage/></WithSusError>,
      layout: "/admin",
      navBarName:'Dashboard'
    },
    {
      path: "/crm/activities",
      name: "Activities",
      rtlName: "أنشطة",
      icon: <SVGIcon style={{color:mainColor}} fontSize={'1.25rem'} viewBox={'0 0 25 25'} svg={LocalActivityIcon}/> ,
      component: <WithSusError><ActivitiesPages/> </WithSusError>,
      layout: "/admin",
      navBarName:'Dashboard'
    },
    {
      path: "/crm/calendar",
      name: "Calendar",
      rtlName: "التقويم",
      icon: <SVGIcon style={{color:mainColor}} fontSize={'1.25rem'} viewBox={'0 0 25 25'} svg={DateRangeIcon}/> ,
      component: <WithSusError><CalendarPage /></WithSusError>,
      layout: "/admin",
      navBarName:'Dashboard'
    },
    {
      path: "/crm/deals",
      name: "Deals",
      rtlName: "صفقات",
      icon: <SVGIcon style={{color:mainColor}} fontSize={'1.25rem'} viewBox={'0 0 25 25'} svg={BusinessIcon}/> ,
      component: <WithSusError><DealsPage/></WithSusError>,
      layout: "/admin",
      navBarName:'Dashboard'
    },
    {
      path: "/crm/dashboard",
      name: "Dashboard",
      rtlName: "لوحة القيادة",
      icon: <SVGIcon style={{color:mainColor}} fontSize={'1.25rem'} viewBox={'0 0 25 25'} svg={DashboardIcon}/> ,
      component: <WithSusError><DashboardPage/></WithSusError>,
      layout: "/admin",
      navBarName:'Dashboard'
    },
  ]
}
];

export default rootRoutes;